function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { asyncToGenerator as _asyncToGenerator } from "../_virtual/_rollupPluginBabelHelpers.js";
import _pt from 'prop-types';
import 'react';
import { jsx } from '@emotion/core';
import useDocumentsAppConfigs from "../hooks/useDocumentsAppConfigs.js";
import { TooltipButton } from '@appfolio/react-gears';
import { observer } from 'mobx-react';
import AnnotationField from "../stores/AnnotationField.js";
import "../types/index.js";
import useStores from "../hooks/useStores.js";
import Header from "./Header.js";
import useUpdateDocument from "../hooks/api/useUpdateDocument.js";
import DocumentDownloadButton from "./DocumentDownloadButton.js";

var useFormValidation = function useFormValidation(fields, submitted) {
  var _useDocumentsAppConfi = useDocumentsAppConfigs(),
      currentUserId = _useDocumentsAppConfi.currentUserId,
      currentUserPermissions = _useDocumentsAppConfi.currentUserPermissions;

  var fieldsByType = AnnotationField.groupFieldsByDataType(fields, currentUserId, currentUserPermissions);
  var signingFieldsMissingValues = fieldsByType.signing.some(function (field) {
    return !field.data.value;
  });
  var dateFieldsMissingValues = fieldsByType.manual.some(function (_ref) {
    var data = _ref.data;
    return data.valueType === 'date' && !data.value;
  });
  var reason;

  if (signingFieldsMissingValues || dateFieldsMissingValues) {
    reason = "All signature and date signed fields assigned to you\n      must be completed before submitting the form";
  } else if (submitted) {
    reason = 'You have already submitted this form. You can only submit a form once.';
  }

  return [!signingFieldsMissingValues && !dateFieldsMissingValues && !submitted, reason];
};

var FillableHeader = function FillableHeader(_ref2) {
  var documentId = _ref2.documentId,
      pageTitle = _ref2.pageTitle,
      pdfTitle = _ref2.pdfTitle,
      submitFormButtonText = _ref2.submitFormButtonText,
      fillableName = _ref2.fillableName,
      onSubmit = _ref2.onSubmit,
      _ref2$headerButtons = _ref2.headerButtons,
      HeaderButtons = _ref2$headerButtons === void 0 ? function () {
    return null;
  } : _ref2$headerButtons,
      onSecondaryLinkClick = _ref2.onSecondaryLinkClick,
      secondaryLinkText = _ref2.secondaryLinkText;

  var _useDocumentsAppConfi2 = useDocumentsAppConfigs(),
      currentUserId = _useDocumentsAppConfi2.currentUserId,
      currentUserPermissions = _useDocumentsAppConfi2.currentUserPermissions;

  var _useStores = useStores(),
      pdfStore = _useStores.pdfStore,
      signatureStore = _useStores.signatureStore;

  var _useUpdateDocument = useUpdateDocument(),
      updateDocument = _useUpdateDocument.updateDocument,
      updatePending = _useUpdateDocument.isLoading;

  var _useFormValidation = useFormValidation(pdfStore.fields, pdfStore.documentSubmitted),
      _useFormValidation2 = _slicedToArray(_useFormValidation, 2),
      submittable = _useFormValidation2[0],
      maybeReason = _useFormValidation2[1];

  var handleSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var updatedDocument;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return updateDocument({
                documentId: documentId,
                fields: pdfStore.fields,
                signature: signatureStore.signature
              });

            case 2:
              updatedDocument = _context.sent;

              if (updatedDocument) {
                pdfStore.submitDocument();
                onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(pdfStore.documentParties.map(function (_ref4) {
                  var id = _ref4.id,
                      userId = _ref4.userId,
                      name = _ref4.name;
                  return {
                    id: id,
                    userId: userId,
                    name: name
                  };
                }));
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleSubmit() {
      return _ref3.apply(this, arguments);
    };
  }();

  return jsx(Header, {
    pageTitle: pageTitle,
    pdfTitle: fillableName ? "".concat(fillableName).concat(pdfTitle ? " | ".concat(pdfTitle) : '') : undefined,
    onSecondaryLinkClick: onSecondaryLinkClick,
    secondaryLinkText: secondaryLinkText
  }, jsx("div", {
    className: "btn p-0"
  }, jsx(TooltipButton, {
    hidden: AnnotationField.getAssignedFields(pdfStore.fields, currentUserId, currentUserPermissions).length === 0,
    disabled: !submittable || updatePending,
    color: "primary",
    tooltip: maybeReason,
    tooltipPlacement: "bottom",
    onClick: handleSubmit,
    className: "js-submit-document-button"
  }, submitFormButtonText)), jsx(DocumentDownloadButton, {
    documentId: documentId,
    title: pdfTitle
  }), jsx(HeaderButtons, null));
};

FillableHeader.displayName = "FillableHeader";
FillableHeader.propTypes = {
  documentId: _pt.string.isRequired,
  pageTitle: _pt.string.isRequired,
  pdfTitle: _pt.string,
  fillableName: _pt.string,
  submitFormButtonText: _pt.string.isRequired,
  onSubmit: _pt.func,
  onSecondaryLinkClick: _pt.func,
  secondaryLinkText: _pt.string,
  children: _pt.node
};
var FillableHeader$1 = observer(FillableHeader);
export default FillableHeader$1;